export default __webpack_public_path__ + "static/decorist-1-4388a2dd2e91615a912ba96b6f24fb21.webp";